import axios from "axios";
import _ from "lodash";
import jwtDecode from "jwt-decode";

import { getAccessToken, getSessionId } from "../storage";

import { store } from "../../store";
import { updateAccessToken, logoutUser } from "../../store/actions/auth";
import { showWarningAlert } from "../../store/actions/alerts";

import { AUTH_REFRESH_ACCESS_TOKEN_URL } from "../../config"

let isTokenRefreshing = false;
let apiRequestQueue = [];

//*** CONFIGURE THE BASE URLs & TIMEOUTs ****/
const axiosInstance = axios.create();
const refreshInstance = axios.create();
const queueInstance = axios.create();

axiosInstance.interceptors.request.use(
    (config) => {
        //*** GET THE ACCESS TOKEN HERE FROM REDUX / STORAGE ****/
        const accessToken = getAccessToken();

        if (accessToken) {
            config.headers["x-access-token"] = accessToken;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

queueInstance.interceptors.request.use(
    (config) => {
        //*** GET THE ACCESS TOKEN HERE FROM REDUX / STORAGE ****/
        const accessToken = getAccessToken();
        if (accessToken) {
            config.headers["x-access-token"] = accessToken;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

function addToApiRequestQueue(cb) {
    apiRequestQueue.push(cb);
}

function processApiQueue() {
    apiRequestQueue.map((cb) => cb());
}

function isAccessTokenValid() {
    //*** GET THE ACCESS TOKEN HERE FROM REDUX / STORAGE ****/
    const accessToken = getAccessToken();

    try {
        const decodedJwt = jwtDecode(accessToken);
        if (_.now() / 1000 > decodedJwt.exp - 1800) {  //30 mins before expiry
            return false;
        } else {
            return true;
        }
    } catch (error) {
        return false;
    }
}

function refreshAccessToken() {
    return new Promise((resolve, reject) => {
        //*** GET THE REFRESH TOKEN HERE FROM REDUX / STORAGE ****/
        let accessToken = getAccessToken();
        let decoded = jwtDecode(accessToken);

        //refresh token
        refreshInstance
            .post(AUTH_REFRESH_ACCESS_TOKEN_URL.url,
                {
                    id: decoded.uid,
                    sessionId: getSessionId()
                },
                {
                    headers: {
                        "x-access-token": accessToken,
                    },
                })
            .then((res) => {
                isTokenRefreshing = false;
                //*** UPDATE THE TOKENS TO REDUX / STORAGE ****/
                accessToken = res.data.accessToken;
                decoded = jwtDecode(accessToken);
                store.dispatch(
                    updateAccessToken({
                        accessToken: accessToken,
                        expiry: decoded.exp,
                        sessionId: getSessionId()
                    })
                );
                // refreshToken = res.data.refreshToken;
                resolve(res);
                //call the pending requests
                processApiQueue();
                //clear the pending requests
                apiRequestQueue = [];
            })
            .catch((err) => {
                console.log("refresh token error ", err.message);
                isTokenRefreshing = false;
                apiRequestQueue = []; // or reject if respose other than 401
                //logout user
                // store.dispatch(logoutUser());
                // reject(err)

                if (!!err.response && err.response.status === 401) {
                    //console.log("401 error - logging out");
                    store.dispatch(logoutUser("force_logout"));
                    store.dispatch(showWarningAlert("401 - Session Expired!"));
                } else {
                    reject(err);
                }

            });
    });
}

export default function makeApiRequest(params) {
    return new Promise((resolve, reject) => {
        if (!isTokenRefreshing) {
            //check if jwt expiring or expired
            //   const decodedJwt = jwtDecode(accessToken);
            if (!isAccessTokenValid()) {
                isTokenRefreshing = true;
                console.log("Token expired - Refreshing");
                //refresh token

                refreshAccessToken()
                    .then(() => {
                        //execute the current request
                        axiosInstance(params)
                            .then((res) => resolve(res))
                            .catch((err) => reject(err));
                    })
                    .catch((err) => {
                        reject(err);
                    });
            } else {
                axiosInstance(params)
                    .then((res) => resolve(res))
                    .catch((err) => reject(err));
            }
        } else {
            return Promise.resolve(
                addToApiRequestQueue(() => {
                    resolve(queueInstance(params));
                })
            );
        }
    });
}